/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktakeReportCalculatedUsageCtrl
 */
angular.module('mercury.modules.stock.stocktakereport')
.controller('StockStocktakeReportCalculatedUsageCtrl', ["dialog", "$filter", "$scope", "$stateParams", "StockItems", "StocktakeReports", function(dialog, $filter, $scope, $stateParams, StockItems, StocktakeReports) {
  $scope.loading = StocktakeReports.calculatedUsage($stateParams.itemId, $stateParams.startTime, $stateParams.endTime);
  $scope.loading.then(function(usage) {
    angular.forEach(usage, function(posItemLink) {
      posItemLink.quantityUsed = (posItemLink.posOrdered + posItemLink.posWasted) * posItemLink.posItemLinkQuantity;
    });

    $scope.posItemUsage = usage;
    $scope.totalQuantityUsed = $filter('sumof')(usage, 'quantityUsed');
  });

  $scope.item = StockItems.get($stateParams.itemId);
  $scope.unitName = $stateParams.unitName;
  $scope.unitRatio = $stateParams.unitRatio;
}]);
